define.alias("shared/components/shared/post/sandbox", "settings/components/shared/post/sandbox");